/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {convertFetchResponseToReactQueryResponse} from '../tools';
import {ApiResponse} from '../types';
import {
    useMutation,
    UseMutationOptions,
    UseMutationResult,
    useQuery,
    useQueryClient,
    UseQueryOptions,
    UseQueryResult,
    QueryClient,
    useInfiniteQuery,
    UseInfiniteQueryOptions,
    UseInfiniteQueryResult,
} from 'react-query';
import {
    AdminWorkerJobsResp,
    AdminWorkerJobsRespFromJSON,
    AdminWorkerJobsRespToJSON,
    AdminWorkerRunReq,
    AdminWorkerRunReqFromJSON,
    AdminWorkerRunReqToJSON,
    AdminWorkerRunResp,
    AdminWorkerRunRespFromJSON,
    AdminWorkerRunRespToJSON,
    AdminWorkerStatusResp,
    AdminWorkerStatusRespFromJSON,
    AdminWorkerStatusRespToJSON,
} from '../models';

import {
    AdminWorkerApi,
    AdminWorkerApiAdminRunWorkerJobRequest,
    AdminWorkerApiAdminWorkerJobsRequest,
} from './AdminWorkerApi';

type AdminPauseWorkerQueryOptions = UseQueryOptions<void, Array<Error>, void, ['adminPauseWorker']>;

let useAdminPauseWorkerQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminPauseWorkerQueryOptions) => AdminPauseWorkerQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminPauseWorkerQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminPauseWorkerQueryOptions
    ) => AdminPauseWorkerQueryOptions | undefined
) {
    useAdminPauseWorkerQueryGlobalOptions = callback;
}

export function getAdminPauseWorkerQueryKey(): ['adminPauseWorker'] {
    return ['adminPauseWorker'];
}

export function useAdminPauseWorkerQuery(
    options?: AdminPauseWorkerQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminPauseWorkerQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminPauseWorker({signal})),
        {
            ...options,
            ...useAdminPauseWorkerQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminPauseWorkerMutationOptions = UseMutationOptions<void, Array<Error>>;

let useAdminPauseWorkerMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminPauseWorkerMutationOptions
      ) => AdminPauseWorkerMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminPauseWorkerMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminPauseWorkerMutationOptions
    ) => AdminPauseWorkerMutationOptions | undefined
) {
    useAdminPauseWorkerMutationGlobalOptions = callback;
}

export function useAdminPauseWorkerMutation(
    options?: AdminPauseWorkerMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminPauseWorker()),
        {
            ...options,
            ...useAdminPauseWorkerMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminPauseWorkerInfiniteQueryKey(): ['adminPauseWorker-infinite'] {
    return ['adminPauseWorker-infinite'];
}

export function useAdminPauseWorkerInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<void, Array<runtime.ApiError>, void, void, ['adminPauseWorker-infinite']>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminPauseWorkerInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminPauseWorker()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminResumeWorkerQueryOptions = UseQueryOptions<void, Array<Error>, void, ['adminResumeWorker']>;

let useAdminResumeWorkerQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminResumeWorkerQueryOptions) => AdminResumeWorkerQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminResumeWorkerQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminResumeWorkerQueryOptions
    ) => AdminResumeWorkerQueryOptions | undefined
) {
    useAdminResumeWorkerQueryGlobalOptions = callback;
}

export function getAdminResumeWorkerQueryKey(): ['adminResumeWorker'] {
    return ['adminResumeWorker'];
}

export function useAdminResumeWorkerQuery(
    options?: AdminResumeWorkerQueryOptions
): UseQueryResult<void, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminResumeWorkerQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminResumeWorker({signal})),
        {
            ...options,
            ...useAdminResumeWorkerQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminResumeWorkerMutationOptions = UseMutationOptions<void, Array<Error>>;

let useAdminResumeWorkerMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminResumeWorkerMutationOptions
      ) => AdminResumeWorkerMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminResumeWorkerMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminResumeWorkerMutationOptions
    ) => AdminResumeWorkerMutationOptions | undefined
) {
    useAdminResumeWorkerMutationGlobalOptions = callback;
}

export function useAdminResumeWorkerMutation(
    options?: AdminResumeWorkerMutationOptions
): UseMutationResult<void, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminResumeWorker()),
        {
            ...options,
            ...useAdminResumeWorkerMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminResumeWorkerInfiniteQueryKey(): ['adminResumeWorker-infinite'] {
    return ['adminResumeWorker-infinite'];
}

export function useAdminResumeWorkerInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<void, Array<runtime.ApiError>, void, void, ['adminResumeWorker-infinite']>,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<void, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminResumeWorkerInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminResumeWorker()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminRunWorkerJobQueryOptions = UseQueryOptions<
    AdminWorkerRunResp,
    Array<Error>,
    AdminWorkerRunResp,
    ['adminRunWorkerJob', AdminWorkerApiAdminRunWorkerJobRequest]
>;

let useAdminRunWorkerJobQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params: AdminWorkerApiAdminRunWorkerJobRequest,
          options?: AdminRunWorkerJobQueryOptions
      ) => AdminRunWorkerJobQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminRunWorkerJobQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params: AdminWorkerApiAdminRunWorkerJobRequest,
        options?: AdminRunWorkerJobQueryOptions
    ) => AdminRunWorkerJobQueryOptions | undefined
) {
    useAdminRunWorkerJobQueryGlobalOptions = callback;
}

export function getAdminRunWorkerJobQueryKey(
    params: AdminWorkerApiAdminRunWorkerJobRequest
): ['adminRunWorkerJob', AdminWorkerApiAdminRunWorkerJobRequest] {
    return ['adminRunWorkerJob', params];
}

export function useAdminRunWorkerJobQuery(
    params: AdminWorkerApiAdminRunWorkerJobRequest,
    options?: AdminRunWorkerJobQueryOptions
): UseQueryResult<AdminWorkerRunResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminRunWorkerJobQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminRunWorkerJob(params, {signal})),
        {
            ...options,
            ...useAdminRunWorkerJobQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminRunWorkerJobMutationOptions = UseMutationOptions<
    AdminWorkerRunResp,
    Array<Error>,
    AdminWorkerApiAdminRunWorkerJobRequest
>;

let useAdminRunWorkerJobMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminRunWorkerJobMutationOptions
      ) => AdminRunWorkerJobMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminRunWorkerJobMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminRunWorkerJobMutationOptions
    ) => AdminRunWorkerJobMutationOptions | undefined
) {
    useAdminRunWorkerJobMutationGlobalOptions = callback;
}

export function useAdminRunWorkerJobMutation(
    options?: AdminRunWorkerJobMutationOptions
): UseMutationResult<AdminWorkerRunResp, Array<runtime.ApiError>, AdminWorkerApiAdminRunWorkerJobRequest> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminRunWorkerJob(params)),
        {
            ...options,
            ...useAdminRunWorkerJobMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminRunWorkerJobInfiniteQueryKey(
    params: AdminWorkerApiAdminRunWorkerJobRequest
): ['adminRunWorkerJob-infinite', AdminWorkerApiAdminRunWorkerJobRequest] {
    return ['adminRunWorkerJob-infinite', params];
}

export function useAdminRunWorkerJobInfiniteQuery(
    params: AdminWorkerApiAdminRunWorkerJobRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminWorkerRunResp,
            Array<runtime.ApiError>,
            AdminWorkerRunResp,
            AdminWorkerRunResp,
            ['adminRunWorkerJob-infinite', AdminWorkerApiAdminRunWorkerJobRequest]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminWorkerRunResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminRunWorkerJobInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminWorkerApi().adminRunWorkerJob({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminWorkerJobsQueryOptions = UseQueryOptions<
    AdminWorkerJobsResp,
    Array<Error>,
    AdminWorkerJobsResp,
    ['adminWorkerJobs', AdminWorkerApiAdminWorkerJobsRequest?]
>;

let useAdminWorkerJobsQueryGlobalOptions:
    | ((
          queryClient: QueryClient,
          params?: AdminWorkerApiAdminWorkerJobsRequest,
          options?: AdminWorkerJobsQueryOptions
      ) => AdminWorkerJobsQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminWorkerJobsQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        params?: AdminWorkerApiAdminWorkerJobsRequest,
        options?: AdminWorkerJobsQueryOptions
    ) => AdminWorkerJobsQueryOptions | undefined
) {
    useAdminWorkerJobsQueryGlobalOptions = callback;
}

export function getAdminWorkerJobsQueryKey(
    params?: AdminWorkerApiAdminWorkerJobsRequest
): ['adminWorkerJobs', AdminWorkerApiAdminWorkerJobsRequest?] {
    return params !== undefined ? ['adminWorkerJobs', params] : ['adminWorkerJobs'];
}

export function useAdminWorkerJobsQuery(
    params?: AdminWorkerApiAdminWorkerJobsRequest,
    options?: AdminWorkerJobsQueryOptions
): UseQueryResult<AdminWorkerJobsResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminWorkerJobsQueryKey(params),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminWorkerJobs(params, {signal})),
        {
            ...options,
            ...useAdminWorkerJobsQueryGlobalOptions?.(queryClient, params, options),
        }
    );
}

type AdminWorkerJobsMutationOptions = UseMutationOptions<
    AdminWorkerJobsResp,
    Array<Error>,
    AdminWorkerApiAdminWorkerJobsRequest | undefined
>;

let useAdminWorkerJobsMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminWorkerJobsMutationOptions
      ) => AdminWorkerJobsMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminWorkerJobsMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminWorkerJobsMutationOptions
    ) => AdminWorkerJobsMutationOptions | undefined
) {
    useAdminWorkerJobsMutationGlobalOptions = callback;
}

export function useAdminWorkerJobsMutation(
    options?: AdminWorkerJobsMutationOptions
): UseMutationResult<AdminWorkerJobsResp, Array<runtime.ApiError>, AdminWorkerApiAdminWorkerJobsRequest | undefined> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminWorkerJobs(params)),
        {
            ...options,
            ...useAdminWorkerJobsMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminWorkerJobsInfiniteQueryKey(
    params?: AdminWorkerApiAdminWorkerJobsRequest
): ['adminWorkerJobs-infinite', AdminWorkerApiAdminWorkerJobsRequest | undefined] {
    return ['adminWorkerJobs-infinite', params];
}

export function useAdminWorkerJobsInfiniteQuery(
    params?: AdminWorkerApiAdminWorkerJobsRequest,
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminWorkerJobsResp,
            Array<runtime.ApiError>,
            AdminWorkerJobsResp,
            AdminWorkerJobsResp,
            ['adminWorkerJobs-infinite', AdminWorkerApiAdminWorkerJobsRequest | undefined]
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminWorkerJobsResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminWorkerJobsInfiniteQueryKey(params),
        async (context) =>
            convertFetchResponseToReactQueryResponse(
                await new AdminWorkerApi().adminWorkerJobs({
                    ...params,
                    page: context.pageParam || (params as any)?.page,
                } as any)
            ),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}

type AdminWorkerStatusQueryOptions = UseQueryOptions<
    AdminWorkerStatusResp,
    Array<Error>,
    AdminWorkerStatusResp,
    ['adminWorkerStatus']
>;

let useAdminWorkerStatusQueryGlobalOptions:
    | ((queryClient: QueryClient, options?: AdminWorkerStatusQueryOptions) => AdminWorkerStatusQueryOptions | undefined)
    | undefined = undefined;

export function registerUseAdminWorkerStatusQueryGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminWorkerStatusQueryOptions
    ) => AdminWorkerStatusQueryOptions | undefined
) {
    useAdminWorkerStatusQueryGlobalOptions = callback;
}

export function getAdminWorkerStatusQueryKey(): ['adminWorkerStatus'] {
    return ['adminWorkerStatus'];
}

export function useAdminWorkerStatusQuery(
    options?: AdminWorkerStatusQueryOptions
): UseQueryResult<AdminWorkerStatusResp, Array<runtime.ApiError>> {
    const queryClient = useQueryClient();
    return useQuery(
        getAdminWorkerStatusQueryKey(),
        async ({signal}) =>
            convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminWorkerStatus({signal})),
        {
            ...options,
            ...useAdminWorkerStatusQueryGlobalOptions?.(queryClient, options),
        }
    );
}

type AdminWorkerStatusMutationOptions = UseMutationOptions<AdminWorkerStatusResp, Array<Error>>;

let useAdminWorkerStatusMutationGlobalOptions:
    | ((
          queryClient: QueryClient,
          options?: AdminWorkerStatusMutationOptions
      ) => AdminWorkerStatusMutationOptions | undefined)
    | undefined = undefined;

export function registerUseAdminWorkerStatusMutationGlobalOptions(
    callback: (
        queryClient: QueryClient,
        options?: AdminWorkerStatusMutationOptions
    ) => AdminWorkerStatusMutationOptions | undefined
) {
    useAdminWorkerStatusMutationGlobalOptions = callback;
}

export function useAdminWorkerStatusMutation(
    options?: AdminWorkerStatusMutationOptions
): UseMutationResult<AdminWorkerStatusResp, Array<runtime.ApiError>, void> {
    const queryClient = useQueryClient();
    return useMutation(
        async (params) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminWorkerStatus()),
        {
            ...options,
            ...useAdminWorkerStatusMutationGlobalOptions?.(queryClient, options),
        }
    );
}

export function getAdminWorkerStatusInfiniteQueryKey(): ['adminWorkerStatus-infinite'] {
    return ['adminWorkerStatus-infinite'];
}

export function useAdminWorkerStatusInfiniteQuery(
    options?: Omit<
        UseInfiniteQueryOptions<
            AdminWorkerStatusResp,
            Array<runtime.ApiError>,
            AdminWorkerStatusResp,
            AdminWorkerStatusResp,
            ['adminWorkerStatus-infinite']
        >,
        'queryKey' | 'queryFn' | 'getNextPageParam'
    >
): UseInfiniteQueryResult<AdminWorkerStatusResp, Array<runtime.ApiError>> {
    return useInfiniteQuery(
        getAdminWorkerStatusInfiniteQueryKey(),
        async (context) => convertFetchResponseToReactQueryResponse(await new AdminWorkerApi().adminWorkerStatus()),
        {
            ...options,
            getNextPageParam(lastPage, allPages) {
                const totalPages = (lastPage as any)?.totalPages || 0;
                if (allPages.length >= totalPages) {
                    return undefined;
                }
                return allPages.length + 1;
            },
        }
    );
}
